import { render } from "./References.vue?vue&type=template&id=426672d3&ts=true"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__